var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiCardMedia from '@material-ui/core/CardMedia';
/**
 * Kareo wrapped component of the Material-UI CardMedia. The prop API has been limited to props defined in CardMediaProps.
 *
 * Material-UI CardMedia: [Docs](https://v4.mui.com/components/cards/), [API](https://v4.mui.com/api/card-media/)
 *
 * @storybook: [Card](http://design.kareoprod.ent/design-system/?path=/story/components-surfaces-card--card-example)
 */
var CardMedia = React.forwardRef(function (props, ref) {
    return React.createElement(MuiCardMedia, __assign({}, props, { ref: ref }));
});
CardMedia.defaultProps = {};
CardMedia.displayName = 'KareoCardMedia';
export default CardMedia;
